import { cardsActions, userActions } from '@modules';
import { CardBindStatusesEnum } from '@modules/cards/types';
import { TMiddleware } from '@modules/types';

import { checkActionsType } from './utils';

export const bindCard: TMiddleware = store => next => action => {
  if (
    checkActionsType(action, [cardsActions.getBindStatus.fulfilled]) &&
    action.payload?.data?.status === CardBindStatusesEnum.succeeded
  ) {
    store.dispatch(userActions.getZHDisclaimer());
  }
  return next(action);
};

export default bindCard;
